import MoreOptions from '@sfly/uig-svg-icon/action/small_options';

const MoreOptionsIcon = () => {
    return (<div className="more-options-icon">
        <MoreOptions/>
    </div>)
}

export default MoreOptionsIcon;